module.exports = __webpack_public_path__ + "static/media/furgoneta.bc7878ed.svg";